import  normalize from 'json-api-normalize';

export class MedicalSchoolModel {

  public static parseMedicalSchool(json: any): MedicalSchoolModel[] | MedicalSchoolModel {
    const data = normalize(json).get([
      'id',
      'title',
      'field_address',
      'field_school_id'
    ]);
    return Array.isArray(data) ? data.map(ms => new MedicalSchoolModel({
      id: ms.id,
      title: ms.title,
      state: ms.field_address ? ms.field_address.administrative_area : '',
      country: ms.field_address ? ms.field_address.country_code : '',
      schoolId: ms.field_school_id
    })) : new MedicalSchoolModel({
      id: data.id,
      title: data.title,
      state: data.field_address ? data.field_address.administrative_area : '',
      country: data.field_address ? data.field_address.country_code : '',
      schoolId: data.field_school_id
    });
  }

  public id: string;
  public title: string;
  public state: string;
  public country: string;
  public schoolId: string;
  public relationship: string;

  constructor(values?: Partial<MedicalSchoolModel>) {
    Object.assign(this, values);
  }
}
